import useAuthStore from '@/domains/authentication/store/auth.store';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type OfficeUserInterface from '@/domains/office/typescript/OfficeUserInterface';
import type OfficeInvitationInterface from '@/domains/office/typescript/OfficeInvitationInterface';
import type OfficeInterface from '@/domains/office/typescript/OfficeInterface';
import type ElementOfficeInterface from '@/domains/office/typescript/ElementOfficeInterface';

export default defineStore('office', () => {
    const authStore = useAuthStore();

    const officeUsers = ref<OfficeUserInterface[]>([]);
    const officeInvitations = ref<OfficeInvitationInterface[]>([]);
    const officeElements = ref<ElementOfficeInterface[]>([]);

    // Derived rather than copied at creation: nothing else ever assigned it, so a copy went stale
    // on an office switch and could not survive a purge — Pinia instances outlive an SPA login,
    // and only initUserInfos() refills the auth store.
    const selectedOffice = computed<OfficeInterface | null>(() => authStore.selectedUserOffice);

    // Setup stores get no automatic $reset(). The directory holds the names and emails of the
    // previous practitioner's colleagues, so it has to go with the rest on logout. selectedOffice
    // needs no line here: it follows the auth store, which resetAllStores() purges too.
    function $reset(): void {
        console.info('reset office store');
        officeUsers.value = [];
        officeInvitations.value = [];
        officeElements.value = [];
    }

    return { officeUsers, officeInvitations, selectedOffice, officeElements, $reset };
});
